export default "__VITE_ASSET__CTY4l$IN__"